import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useGetLookUpDropdownListQuery } from '../../../../../../api';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../../../../../contexts/LanguageContext';

const AlokasyonDropdown = ({ value, onChange, className, disabled }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const [selectedWarrantyType, setWarrantyType] = useState(null);
    const prevValueRef = useRef(value);

    const { data: alokasyonList = [], isLoading: isLoadingType } = useGetLookUpDropdownListQuery({
        RowCount: 100,
        GroupCode: 'XXBOS_ALOKASYON',
        LanguageId: getCurrentLanguageId()
    });

    const warrantyTypeOptions = useMemo(() => {
        return alokasyonList.map((type) => ({
            id: type.id,
            text: type.translatedText,
            displayValue: type.translatedText
        }));
    }, [alokasyonList]);

    const handleSelectionChange = (e) => {
        setWarrantyType(e.value);
        onChange(e.value ? e.value.id : '');
    };

    useEffect(() => {
        const valueChanged = prevValueRef.current !== value;
        prevValueRef.current = value;

        // If value hasn't changed and selectedWarrantyType matches, skip update
        if (selectedWarrantyType && !valueChanged) {
            if (typeof value === 'string' && selectedWarrantyType.id === value) {
                return;
            } else if (typeof value === 'object' && value !== null && selectedWarrantyType.id === value.id) {
                return;
            } else if (typeof value === 'number' && selectedWarrantyType.id === value.toString()) {
                return;
            }
        }

        if (warrantyTypeOptions.length > 0 && value) {
            let found;

            if (typeof value === 'string') {
                found = warrantyTypeOptions.find((option) => option.id === value || option.displayValue?.includes(value) || option.text === value);
            } else if (typeof value === 'number') {
                found = warrantyTypeOptions.find((option) => option.id === value.toString() || option.id === value);
            } else if (typeof value === 'object' && value !== null) {
                found = warrantyTypeOptions.find((option) => option.id === value.id || option.displayValue === value.displayValue);
            }

            if (found && (!selectedWarrantyType || selectedWarrantyType.id !== found.id)) {
                setWarrantyType(found);
            } else if (typeof value === 'object' && value !== null && !found) {
                const newOption = {
                    id: value.id || value.chassisNo || '',
                    text: value.text || value.translatedText || value.id || value.chassisNo || '',
                    displayValue: value.displayValue || `${value.id || value.chassisNo || ''} - ${value.text || value.translatedText || ''}`
                };
                setWarrantyType(newOption);
            }
        } else if (!value) {
            setWarrantyType(null);
        }
    }, [value, warrantyTypeOptions]);

    return (
        <Dropdown
            disabled={disabled}
            value={selectedWarrantyType}
            options={warrantyTypeOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={th('warrantyClaims.detail.form.allocationPlaceholder')}
            loading={isLoadingType}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};
export default AlokasyonDropdown;
